<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="helpPermissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="helpPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><em class="fas fa-warehouse"></em></span
    >{{ "RegistrationForm.Header" | translate }}
  </h1>
  <p-card>
    <form [formGroup]="createForm">
      <div class="grid">
        <div class="p-fluid col-12 grid">
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <div class="block mb-1">
              <span class="requiredStart">*</span
              >{{ "RegistrationForm.Create.Forwarder" | translate }}
            </div>
            <div class="block">
              <p-dropdown
                formControlName="forwarderCode"
                [options]="forwarderOptions"
                [filter]="true"
                filterBy="label"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              ></p-dropdown>
            </div>
            <div class="block flex">
              <div
                *ngIf="
                  (submitted || createForm.controls.forwarderCode.touched) &&
                  createForm?.controls?.forwarderCode?.errors?.required
                "
                class="flex-1"
              >
                <small class="p-invalid">{{
                  "Common.Button.Required" | translate
                }}</small>
              </div>
              <div class="flex-none">&nbsp;</div>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <div class="block mb-1">
              <span class="requiredStart">*</span
              >{{ "RegistrationForm.Create.Vendor" | translate }}
            </div>
            <div class="block">
              <p-autoComplete
                formControlName="vendorName"
                [suggestions]="vendorSuggests"
                (completeMethod)="getVendorOptions($event)"
              ></p-autoComplete>
            </div>
            <div class="block flex">
              <div
                *ngIf="
                  (submitted || createForm.controls.vendorName.touched) &&
                  createForm?.controls?.vendorName?.errors?.required
                "
                class="flex-1"
              >
                <small class="p-invalid">{{
                  "Common.Button.Required" | translate
                }}</small>
              </div>
              <div class="flex-none">&nbsp;</div>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <div class="block mb-1">
              <span class="requiredStart">*</span
              >{{ "RegistrationForm.Create.Org" | translate }}
            </div>
            <div class="block">
              <p-dropdown
                formControlName="orgId"
                [options]="orgOptions"
                [filter]="true"
                filterBy="label"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              ></p-dropdown>
            </div>
            <div class="block flex">
              <div
                *ngIf="
                  (submitted || createForm.controls.orgId.touched) &&
                  createForm?.controls?.orgId?.errors?.required
                "
                class="flex-1"
              >
                <small class="p-invalid">{{
                  "Common.Button.Required" | translate
                }}</small>
              </div>
              <div class="flex-none">&nbsp;</div>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <div class="block mb-1">
              <span class="requiredStart">*</span
              >{{ "RegistrationForm.Create.TotalCartonNo" | translate }}
            </div>
            <div class="block">
              <input type="text" pInputText formControlName="totalCtn" />
            </div>
            <div class="block flex">
              <div
                *ngIf="
                  (submitted || createForm.controls.totalCtn.touched) &&
                  createForm?.controls?.totalCtn?.errors?.required
                "
                class="flex-1"
              >
                <small class="p-invalid">{{
                  "Common.Button.Required" | translate
                }}</small>
              </div>
              <div class="flex-none">&nbsp;</div>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <div class="block mb-1">
              <span class="requiredStart">*</span
              >{{ "RegistrationForm.Create.ReferenceType" | translate }}
            </div>
            <div class="block">
              <p-dropdown
                formControlName="referenceType"
                [options]="referenceTypeOptions"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                (onClick)="selectReferenceType()"
              ></p-dropdown>
            </div>
            <div class="block flex">
              <div
                *ngIf="
                  (submitted || createForm.controls.referenceType.touched) &&
                  createForm?.controls?.referenceType?.errors?.required
                "
                class="flex-1"
              >
                <small class="p-invalid">{{
                  "Common.Button.Required" | translate
                }}</small>
              </div>
              <div class="flex-none">&nbsp;</div>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <div class="block mb-1">
              <span class="requiredStart">*</span
              >{{ "RegistrationForm.Create.Referencekey" | translate }}
            </div>
            <div class="block">
              <input type="text" pInputText formControlName="referenceKey" />
            </div>
            <div class="block flex">
              <div
                *ngIf="
                  (submitted || createForm.controls.referenceKey.touched) &&
                  createForm?.controls?.referenceKey?.errors?.required
                "
                class="flex-1"
              >
                <small class="p-invalid">{{
                  "Common.Button.Required" | translate
                }}</small>
              </div>
              <div class="flex-none">&nbsp;</div>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-3 laas-calendar">
            <laas-calendar
              #edcDate
              [title]="'RegistrationForm.Create.EDC'"
              [requiredStar]="true"
              [enableMaxDateIsToday]="false"
              [selectionMode]="'single'"
              [showCustomTime]="true"
              (onDateChange)="dateOnChange($event, 'edcDate')"
            >
            </laas-calendar>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <div class="block mb-1">
              {{ "RegistrationForm.Create.PalletCnt" | translate }}
            </div>
            <div class="block">
              <input type="text" pInputText formControlName="palletCnt" />
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <div class="block mb-1">
              {{ "RegistrationForm.Create.Abnormal" | translate }}
            </div>
            <div class="block">
              <p-multiSelect
                formControlName="abnormalReference"
                [options]="abnormalOptions"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                filterBy="label"
              >
              </p-multiSelect>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <div class="block mb-1">
              {{ "RegistrationForm.Create.Creater" | translate }}
            </div>
            <div class="block mt-2">
              {{ createForm?.value.createUser }}
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <div class="block mb-1">
              {{ "RegistrationForm.Create.CreateDt" | translate }}
            </div>
            <div class="block mt-2">
              {{
                createForm?.value.createDt
                  | date
                    : "yyyy-MM-dd HH:mm:ss"
                    : this.laasSetting.facilityTimeZone
              }}
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="inline-block mb-1">
            <button
              pButton
              type="button"
              (click)="saveBtnClick($event)"
              label="{{ 'Common.Button.Save' | translate }}"
            ></button>
          </div>
          <div class="inline-block mb-1">
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Import' | translate }}"
              (click)="visibleChangeOfImport(true)"
              class="ml-4"
            ></button>
          </div>
          <div class="inline-block mb-1">
            <button
              pButton
              pRipple
              label="{{ 'IntransitImport.Button.Download' | translate }}"
              class="ml-4"
              (click)="templateDownloadBtn()"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </p-card>
  <ng-container *ngIf="isShowImport">
    <laas-registration-import
      [(visible)]="isShowImport"
      (visibleChange)="visibleChangeOfImport($event)"
    ></laas-registration-import>
  </ng-container>
</div>
<help-dock
  [permissionCode]="helpPermissionCode"
  [lang]="currentLang">
</help-dock>
